import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function ModulesGrid() {
  const tomos = [{
    id: 1,
    lightColor: 'bg-[#130a22]/50',
    borderColor: 'border-[#3a2456]/50',
    textColor: 'text-slate-300',
    emoji: '📘',
    title: 'Vocabulario Básico LSA',
    subtitle: 'Todo lo que necesitás saber para dar tus primeros pasos en la comunicación',
    desc: 'Abecedario dactilológico, números, saludos, colores, días de la semana, familia y verbos fundamentales. Explicado con claridad visual para que memorices las señas sin esfuerzo y con la configuración manual correcta.',
    resuelve: 'El miedo a quedar en blanco. Este módulo te da la base sólida para iniciar cualquier interacción básica con seguridad.',
    resultado: 'Podés presentarte, saludar y entender información básica de inmediato, rompiendo el hielo al instante.',
    tags: ['ABECEDARIO', 'NÚMEROS', 'SALUDOS', 'FAMILIA', 'VERBOS']
  }, {
    id: 2,
    lightColor: 'bg-[#130a22]/50',
    borderColor: 'border-[#3a2456]/50',
    textColor: 'text-slate-300',
    emoji: '📘',
    title: 'Frases y Diálogos',
    subtitle: 'De palabras sueltas a conversaciones reales y fluidas',
    desc: 'Estructuras para preguntas cotidianas, indicaciones de lugares, expresiones de tiempo, emociones y diálogos comunes en la calle, el transporte o comercios. Cómo hilar las señas de forma natural.',
    resuelve: 'La frustración de saber palabras pero no saber cómo conectarlas para expresar una idea completa.',
    resultado: 'Mantenés conversaciones cortas y útiles en entornos cotidianos sin depender de escribir en un papel.',
    tags: ['DIÁLOGOS', 'PREGUNTAS', 'EMOCIONES', 'TIEMPO', 'LUGARES']
  }, {
    id: 3,
    lightColor: 'bg-[#130a22]/50',
    borderColor: 'border-[#3a2456]/50',
    textColor: 'text-slate-300',
    emoji: '📘',
    title: 'Gramática LSA',
    subtitle: 'Entendé cómo funciona el idioma visualmente (no es español con señas)',
    desc: 'Estructura Tiempo-Lugar-Sujeto-Objeto-Verbo. Uso del espacio, clasificadores, direccionalidad de los verbos, expresión facial como rasgo gramatical y pluralización. La clave para la verdadera fluidez.',
    resuelve: 'El error más común: hablar en español y meter señas en el medio. Este módulo te enseña a pensar visualmente.',
    resultado: 'Tus oraciones tienen sentido real para una persona sorda. Te comunicás con claridad y respeto por su idioma.',
    tags: ['ESTRUCTURA', 'ESPACIO', 'CLASIFICADORES', 'EXPRESIÓN FACIAL', 'VERBOS DIRECCIONALES']
  }, {
    id: 4,
    lightColor: 'bg-[#130a22]/50',
    borderColor: 'border-[#3a2456]/50',
    textColor: 'text-slate-300',
    emoji: '📘',
    title: 'Cultura Sorda Argentina',
    subtitle: 'El módulo que te transforma de estudiante a aliado de la comunidad',
    desc: 'Identidad sorda, mitos y realidades, historia de la comunidad en Argentina, pautas de comportamiento visual, cómo llamar la atención correctamente y terminología adecuada (por qué no decir "sordomudo").',
    resuelve: 'El miedo a ofender por ignorancia. Entender el idioma sin entender la cultura es hacer el trabajo a medias.',
    resultado: 'Interactuás con profundo respeto y empatía, ganándote la confianza y el aprecio de la comunidad sorda.',
    tags: ['IDENTIDAD', 'MITOS', 'HISTORIA', 'PAUTAS VISUALES', 'TERMINOLOGÍA']
  }, {
    id: 5,
    lightColor: 'bg-[#130a22]/50',
    borderColor: 'border-[#3a2456]/50',
    textColor: 'text-slate-300',
    emoji: '📘',
    title: 'Interpretación Social',
    subtitle: 'Llevá la LSA a tu entorno laboral, médico o educativo',
    desc: 'Vocabulario específico para atención al público, emergencias médicas, trámites bancarios, ámbito escolar y entrevistas de trabajo. Cómo actuar como puente comunicativo básico en situaciones reales.',
    resuelve: 'La barrera de acceso en instituciones. Te da las herramientas para garantizar que una persona sorda reciba la atención que merece.',
    resultado: 'Tu lugar de trabajo se vuelve accesible. Podés asistir y guiar a personas sordas en situaciones críticas o cotidianas.',
    tags: ['ATENCIÓN AL PÚBLICO', 'SALUD', 'EDUCACIÓN', 'TRÁMITES', 'ACCESIBILIDAD']
  }, {
    id: 6,
    lightColor: 'bg-[#3a2456]/60',
    borderColor: 'border-[#5b3a85]/80',
    textColor: 'text-slate-200',
    emoji: '⭐',
    title: 'Recursos Digitales LSA',
    subtitle: 'El módulo que potencia tu aprendizaje y te permite enseñar a otros',
    desc: 'Herramientas tecnológicas, apps recomendadas, cómo grabar videos accesibles, estrategias didácticas para enseñar LSA básica en tu entorno, y cómo crear material visual efectivo. Todo adaptado a Argentina.',
    resuelve: 'Saber LSA no alcanza si querés difundirla. Este módulo te da el sistema para crear entornos accesibles y capacitar a tu equipo.',
    resultado: 'Pasás de ser un aprendiz a un promotor activo de la inclusión, con recursos listos para usar y compartir.',
    tags: ['HERRAMIENTAS', 'APPS', 'DIDÁCTICA', 'VIDEOS ACCESIBLES', 'DIFUSIÓN'],
    badge: '⭐ EL MÁS POPULAR'
  }];
  const bonos = [{
    id: 1,
    title: 'Diccionario Visual de Señas Imprimible',
    valor: '$18.000 ARS',
    desc: 'Más de 500 señas organizadas por categoría listas para imprimir o llevar en el celular. Búsqueda rápida por tema (alimentos, profesiones, lugares, etc.) para consultar en cualquier momento de duda.'
  }, {
    id: 2,
    title: 'Guía de Configuraciones de Manos',
    valor: '$15.000 ARS',
    desc: 'El mapa visual exacto de cómo posicionar los dedos para cada seña. Evitá confusiones comunes y mejorá tu precisión motriz desde el primer día con esta guía de referencia rápida.'
  }, {
    id: 3,
    title: 'Catálogo de Señas por Categoría',
    valor: '$12.000 ARS',
    desc: 'Fichas visuales temáticas ideales para docentes o para repasar antes de una situación específica (ej: vocabulario médico antes de una consulta). Material didáctico de alto valor.'
  }, {
    id: 4,
    title: 'Plantillas para Redes Sociales sobre LSA',
    valor: '$10.000 ARS',
    desc: '30 plantillas editables para Instagram y Facebook. Posts sobre mitos, señas del día, efemérides de la comunidad sorda. Diseñadas para que tu institución se vea inclusiva y profesional.'
  }];
  return <section className="py-20 bg-[#0f1d35]" data-id="element-158">
      <div className="container mx-auto px-4" data-id="element-159">
        <div className="text-center mb-16" data-id="element-160">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#0a1428]/80 text-slate-200 border border-[#1e3a5f]/50 font-bold mb-6 text-[16px]" data-id="element-161">
            📗 LOS 6 TOMOS
          </div>
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[24px]" data-id="element-162">
            Un tomo por cada dimensión de la meteorología argentina
          </h2>
          <p className="text-slate-300 font-medium text-[16px]" data-id="element-163">
            Todo el sistema didáctico resuelto para docentes de Argentina.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto mb-20" data-id="element-164">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-[#1e3a5f] bg-[#0a1428]/80 overflow-hidden shadow-lg hover:shadow-xl hover:border-slate-400/30 transition-all flex flex-col h-full relative" data-id="element-165">
              {tomo.badge && <div className="absolute top-0 right-0 bg-slate-200 text-slate-950 font-bold text-xs px-3 py-1 rounded-bl-lg z-10" data-id="element-166">
                  {tomo.badge}
                </div>}
              <div className={`${tomo.lightColor} p-4 border-b ${tomo.borderColor} flex items-center gap-3`} data-id="element-167">
                <div className="text-3xl" data-id="element-168">{tomo.emoji}</div>
                <div data-id="element-169">
                  <p className={`text-xs font-bold uppercase tracking-wider ${tomo.textColor}`} data-id="element-170">
                    Tomo {tomo.id}
                  </p>
                  <h3 className="font-bold text-white text-lg leading-tight" data-id="element-171">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-172">
                <p className="font-semibold text-slate-300 mb-3 pb-3 border-b border-[#1e3a5f]" data-id="element-173">
                  {tomo.subtitle}
                </p>
                <p className="text-slate-300 text-sm leading-relaxed mb-4" data-id="element-174">
                  {tomo.desc}
                </p>
                <div className="bg-[#0f1d35]/50 p-3 rounded-lg mb-4 border border-[#1e3a5f]/50" data-id="element-175">
                  <p className="text-xs text-slate-400 mb-1" data-id="element-176">
                    <strong data-id="element-177">¿Qué resuelve en tu clase?</strong>
                  </p>
                  <p className="text-sm text-slate-300" data-id="element-178">{tomo.resuelve}</p>
                </div>
                <div className="bg-blue-900/20 p-3 rounded-lg mb-4 border border-blue-800/30" data-id="element-179">
                  <p className="text-xs text-blue-300 mb-1" data-id="element-180">
                    <strong data-id="element-181">Resultado:</strong>
                  </p>
                  <p className="text-sm text-slate-200" data-id="element-182">{tomo.resultado}</p>
                </div>
                <div className="mt-auto flex flex-wrap gap-1.5" data-id="element-183">
                  {tomo.tags.map((tag, j) => <span key={j} className="text-[10px] font-bold uppercase tracking-wider bg-[#1e3a5f] text-slate-300 px-2 py-1 rounded" data-id="element-184">
                      {tag}
                    </span>)}
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mb-12 border-t border-[#1e3a5f] pt-16" data-id="element-185">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#0a1428]/80 text-slate-200 border border-slate-400/30 font-bold mb-6 text-[16px]" data-id="element-186">
            🎁 LOS 4 BONOS ESTRATÉGICOS
          </div>
          <h2 className="md:text-4xl font-extrabold text-white mb-4 text-[22px]" data-id="element-187">
            Siempre incluidos
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto mb-12" data-id="element-188">
          {bonos.map((bono, i) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-[#1e3a5f] bg-[#0a1428]/80 p-6 flex flex-col h-full relative overflow-hidden" data-id="element-189">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-slate-400 to-slate-200" data-id="element-190"></div>
              <h4 className="font-bold text-slate-300 mb-2 mt-2" data-id="element-191">
                BONO 0{bono.id}
              </h4>
              <h3 className="font-bold text-white text-lg mb-3" data-id="element-192">
                {bono.title}
              </h3>
              <p className="text-xs font-bold text-slate-400 mb-4 pb-3 border-b border-[#1e3a5f]" data-id="element-193">
                Valor real: <span className="line-through" data-id="element-194">{bono.valor}</span> →{' '}
                <span className="text-slate-200" data-id="element-195">GRATIS</span>
              </p>
              <p className="text-slate-300 text-sm leading-relaxed flex-grow" data-id="element-196">
                {bono.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-gradient-to-br from-[#0f1d35] to-[#1e3a5f] rounded-2xl p-6 md:p-8 border border-slate-400/30 text-center shadow-2xl" data-id="element-197">
          <p className="text-slate-300 font-medium mb-2" data-id="element-198">
            Valor total de los 4 bonos: $55.000 ARS
          </p>
          <p className="text-2xl md:text-3xl font-black text-white mb-2" data-id="element-199">
            Tu precio hoy: <span className="text-slate-200" data-id="element-200">🎁 GRATIS</span> con
            tu Megapack
          </p>
        </motion.div>
      </div>
    </section>;
}